enum ElectionType {
    ORDINARY = 10,
    EXTRAORDINARY = 20,
    ELECTORALVOTE = 30,
    FILLVOTE = 40,
    EXTRAORDINARYFILLVOTE = 50
}
export default ElectionType;